class LLOrderProcess {
  constructor(root) {
    this.root = root;
    this.video = root.querySelector('video');
    this.tabs = [...root.querySelectorAll('[data-ll-order-tab]')];
    this.cues = this.tabs.map((tab) => Number.parseFloat(tab.dataset.cue) || 0);
    this.startTime = Number.parseFloat(root.dataset.startTime) || 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.tabs.length) return;

    this.root.classList.add('is-ready');
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.selectStep(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
    if (this.video) {
      this.video.dataset.llOrderVideo = '';
      this.video.loop = false;
      this.video.controls = false;
      this.video.addEventListener('loadedmetadata', () => this.skipIntro());
      this.video.addEventListener('seeked', () => this.markVideoReady());
      this.video.addEventListener('timeupdate', () => this.onTimeUpdate());
      this.video.addEventListener('play', () => this.root.classList.remove('is-paused-for-step'));
      this.video.addEventListener('ended', () => this.root.classList.remove('is-paused-for-step'));

      if (this.reducedMotion) {
        this.video.autoplay = false;
        this.video.pause();
      }
      if (this.video.readyState >= 1) this.skipIntro();
    }

    this.activate(this.tabs.findIndex((tab) => tab.classList.contains('is-active')));
  }

  activate(index, focus = false) {
    const safeIndex = index < 0 ? 0 : Math.min(index, this.tabs.length - 1);

    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === safeIndex;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (focus) this.tabs[safeIndex].focus();
  }

  selectStep(index, focus = false) {
    this.activate(index, focus);
    if (!this.video) return;

    const cue = this.startTime + this.cues[index];
    this.video.currentTime = Math.min(cue, this.video.duration || cue);
    this.video.play().catch(() => {});
    this.onTimeUpdate();
  }

  skipIntro() {
    if (!this.video) return;
    if (this.startTime > 0 && this.video.currentTime < this.startTime) {
      this.video.currentTime = Math.min(this.startTime, this.video.duration || this.startTime);
    } else {
      this.markVideoReady();
    }
  }

  markVideoReady() {
    if (!this.video || this.video.currentTime + 0.05 < this.startTime) return;
    this.root.classList.add('is-video-ready');
  }

  onTimeUpdate() {
    if (!this.video) return;

    let activeIndex = 0;
    const visibleTime = Math.max(0, this.video.currentTime - this.startTime);
    this.cues.forEach((cue, index) => {
      if (visibleTime >= cue) activeIndex = index;
    });
    this.activate(activeIndex);
  }

  onKeydown(event, index) {
    let nextIndex = index;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (index + 1) % this.tabs.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    this.selectStep(nextIndex, true);
  }
}

const initLLOrderProcesses = (container = document) => {
  container.querySelectorAll('[data-ll-order-process]').forEach((root) => {
    if (root.dataset.llInitialized === 'true') return;
    root.dataset.llInitialized = 'true';
    new LLOrderProcess(root);
  });
};

document.addEventListener('DOMContentLoaded', () => initLLOrderProcesses());
document.addEventListener('shopify:section:load', (event) => {
  initLLOrderProcesses(event.target);
});
